define('models/pages/trade/basket-item',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var BasketItem = Model.extend({
        urlPath: '/basket-item',
        defaults: {
            idTradeGoods: null,
            comment: ''
        },
        getAttributes: function() {
            var result = Model.prototype.getAttributes.apply(this, arguments);
            if (this.collection && this.collection.onGetAttributes) {
                result = this.collection.onGetAttributes(result);
            }
            return result;
        },
        destroy: function() {
            this.urlPath = this.urlPath + '/' + this.get('id');//????????????
            Model.prototype.destroy.apply(this, arguments);
        }
    });

    return BasketItem;
});
